export default __webpack_public_path__ + "static/media/agents-zoom.c41dd4e2.png";